// extracted by mini-css-extract-plugin
export default {"mb20":"Settings_mb20_ckFJj"};